export enum ProfessionalType {
  DOCTOR = 'doctor',
  DENTIST = 'dentist',
  PHARMACIST = 'pharmacist',
  BIOMEDIC = 'biomedic',
  VETERINARIAN = 'veterinarian'
}
